
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.755 15.637h4.407v1.84H4.665a.803.803 0 00-.814.79c0 .438.365.792.814.792h10.91c.45 0 .815-.354.815-.791a.803.803 0 00-.814-.791h-3.34v-1.84h4.687c1.012 0 1.834-.776 1.875-1.744H1.88c.041.968.864 1.744 1.875 1.744zm13.17-13.54H3.755c-1.037 0-1.877.815-1.877 1.821v8.998h16.924V3.918c0-1.006-.842-1.82-1.877-1.82zM6.556 9.634a.478.478 0 01-.078.685.515.515 0 01-.707-.074L3.968 8.068a.476.476 0 01-.014-.593l1.803-2.4a.513.513 0 01.703-.108.478.478 0 01.112.681L4.995 7.746l1.561 1.887zm4.955-4.272l-1.82 4.912a.503.503 0 01-.645.293.483.483 0 01-.302-.625l1.82-4.912a.51.51 0 01.644-.295.487.487 0 01.303.627zm5.201 2.707l-1.803 2.176a.512.512 0 01-.707.074.478.478 0 01-.078-.685l1.56-1.885L14.11 5.65a.478.478 0 01.111-.681.513.513 0 01.703.107l1.803 2.4a.473.473 0 01-.014.592z","fill":"currentColor"}})])
          )
        }
      }
    